import { http } from './config'

export default {
  getAllLocalities: () => {
    return http.get('localities')
  },

  getAllLocalitiesWithoutLimit: () => {
    return http.get('localities/all_localities')
  },

  getFilteredLocalities: (params) => {
    return http.get('localities', {params})
  },

  getLocalityById: (localityId) => {
    return http.get('localities/' + localityId)
  },

  createLocality: (localityParams) => {
    return http.post('localities', {
      code: localityParams.code,
      name: localityParams.name,
      address: localityParams.address,
      district: localityParams.district,
      city: localityParams.city,
      state: localityParams.state,
      size: localityParams.size,
      management: localityParams.management,
      region: localityParams.region,
      regional: localityParams.regional
    })
  },

  updateLocality: (localityParams) => {
    return http.put('localities/' + localityParams.id, {
      code: localityParams.code,
      name: localityParams.name,
      address: localityParams.address,
      district: localityParams.district,
      city: localityParams.city,
      state: localityParams.state,
      size: localityParams.size,
      management: localityParams.management,
      region: localityParams.region,
      regional: localityParams.regional
    })
  },

  deleteLocality: (localityId) => {
    return http.delete('localities/' + localityId)
  }
}
